import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { AIAgentEmailGraphContainer } from '../../../../components/AIAgentEmailGraph';
import type { EmailPreview } from '../../../../services/jsonParser/types';
import {
  StyledChartWrapper,
  StyledPickerBackArrow,
  StyledPickerHeader,
  StyledPickerHeaderTitle,
  StyledResultContainer,
} from '../styles';

import {
  StyledPreviewApplyButton,
  StyledPreviewCardOverlay,
  StyledPreviewsSection,
  StyledPreviewsTitle,
} from './styles';

type AIOutreachAlternativeInsightsProps = {
  emailPreviews: EmailPreview[];
  onApplyPreview: (preview: EmailPreview, index: number) => void;
  onBack: () => void;
};

export const AIOutreachAlternativeInsights = ({
  emailPreviews,
  onApplyPreview,
  onBack,
}: AIOutreachAlternativeInsightsProps) => {
  const { t } = useTranslation();

  return (
    <StyledResultContainer $grow data-automation="AIOutreachAlternativeInsights">
      <StyledPreviewsSection>
        <StyledPickerHeader>
          <StyledPickerBackArrow onClick={onBack}>
            <SWReactIcons iconName="arrow-left" size="xs" iconColor={colorsPalettes.carbon[500]} />
          </StyledPickerBackArrow>
          <StyledPickerHeaderTitle>
            {t('company.overview.ai-outreach.back_to_email', 'Present alternative insights')}
          </StyledPickerHeaderTitle>
        </StyledPickerHeader>
        <StyledPreviewsTitle>{t('company.overview.ai-outreach.alternatives', 'Choose a visual')}</StyledPreviewsTitle>
        {emailPreviews.map((preview, index) =>
          preview.chartJson ? (
            <StyledChartWrapper key={index} onClick={() => onApplyPreview(preview, index)}>
              <AIAgentEmailGraphContainer
                chart={preview.chartJson}
                overlay={
                  <StyledPreviewCardOverlay>
                    <StyledPreviewApplyButton>{t('common.apply', 'Apply')}</StyledPreviewApplyButton>
                  </StyledPreviewCardOverlay>
                }
              />
            </StyledChartWrapper>
          ) : null
        )}
      </StyledPreviewsSection>
    </StyledResultContainer>
  );
};
